export interface BlacklistRule {
  id: number;
  deviceAddress: string | null;
  phoneNumber: string | null;
  reason: string;           // A~G
  note: string | null;
  deviceVersion: string | null;  // 'V1' | 'V2' | null
  createdAt: string;
  createdBy: string | null;
}

export interface BlacklistRuleCreateRequest {
  deviceAddress?: string;
  phoneNumber?: string;
  reason: string;
  note?: string;
  deviceVersion?: string;   // 'V1' | 'V2' | undefined(미지정)
}

export const REASON_LABELS: Record<string, string> = {
  A: 'A',
  B: 'B',
  C: 'C',
  D: 'D',
  E: 'E',
  F: 'F',
  G: 'G',
};

export const DEVICE_VERSION_OPTIONS = [
  { value: '', label: '미지정' },
  { value: 'V1', label: 'V1' },
  { value: 'V2', label: 'V2' },
];
